export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Администрирование: Генерация массива ТК",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
